import React from "react";
import { Row, Col } from "react-flexbox-grid";
import CountUp from "react-countup";
import Grid from "material-ui-next/Grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { CardValue, CurrencyValue, InfoTooltip } from "components/support";
import Big from "big.js";

class QuickCards extends React.Component {
  render() {
    const averageProducts = this.props.result.average_products || 0;
    return (
      <Row center="xs">
        <Col xs={12} sm={4} md>
          <Paper elevation={1} className="p-sm full-height">
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className="full-height"
            >
              <Grid item xs>
                <Typography type="headline">Total de Vendas</Typography>
                <CardValue>
                  <CurrencyValue
                    value={this.props.result.sales_count * 100}
                    type="integer"
                  />
                </CardValue>
              </Grid>
            </Grid>
          </Paper>
        </Col>
        <Col xs={12} sm={4} md>
          <Paper elevation={1} className="p-sm full-height">
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className="full-height"
            >
              <Grid style={{ position: "relative" }} item xs>
                <Typography type="headline">
                  Ticket Médio
                  <InfoTooltip hint="Valor do faturamento dividido pela quantidade de vendas." />
                </Typography>
                <CardValue>
                  <CurrencyValue
                    value={this.props.result.average_ticket}
                    type="money"
                  />
                </CardValue>
              </Grid>
            </Grid>
          </Paper>
        </Col>
        <Col xs={12} sm={4} md>
          <Paper elevation={1} className="p-sm full-height">
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className="full-height"
            >
              <Grid item xs>
                <Typography type="headline">
                  Média de produtos por venda
                </Typography>
                <CardValue>
                  <CurrencyValue value={averageProducts} />
                </CardValue>
              </Grid>
            </Grid>
          </Paper>
        </Col>
        <Col xs={12} sm={4} md>
          <Paper elevation={1} className="p-sm full-height">
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className="full-height"
            >
              <Grid item xs>
                <Typography type="headline">Vendas com Desconto</Typography>
                <CardValue>
                  <CurrencyValue
                    value={this.props.result.sales_with_discount * 100}
                    type="integer"
                  />
                </CardValue>
              </Grid>
            </Grid>
          </Paper>
        </Col>
        <Col xs={12} sm={4} md>
          <Paper elevation={1} className="p-sm full-height">
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className="full-height"
            >
              <Grid item xs>
                <Typography type="headline">% médio de desconto</Typography>
                <CardValue>
                  <CountUp //TODO
                    start={0}
                    end={Big(this.props.result.average_discount || 0)
                      .times(100)
                      .toFixed(2)}
                    duration={1.5}
                    useEasing
                    useGrouping
                    separator="."
                    decimal=","
                    decimals={2}
                    suffix="%"
                  />
                </CardValue>
              </Grid>
            </Grid>
          </Paper>
        </Col>
      </Row>
    );
  }
}

export default QuickCards;



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/quick-cards/view.jsx